/* eslint-disable no-useless-escape */
/* eslint-disable consistent-return */

// Custom sort: numbers first, "-" always last
export const numericSortDashLast = (rowA, rowB, columnId) => {
  const aRaw = rowA.getValue(columnId)
  const bRaw = rowB.getValue(columnId)

  // Check for "-" special case
  const aIsDash = aRaw === '-'
  const bIsDash = bRaw === '-'

  if (aIsDash && bIsDash) return 0 // both are "-"
  if (aIsDash) return 1 // a should go after b
  if (bIsDash) return -1 // b should go after a

  const aNum = parseFloat(aRaw)
  const bNum = parseFloat(bRaw)

  return aNum - bNum
}

// Custom sort: alphanumeric with natural order, case-insensitive, "-" always last
export const alphaNumSortDashLast = (rowA, rowB, columnId) => {
  const aRaw = rowA.getValue(columnId)
  const bRaw = rowB.getValue(columnId)

  const aIsDash = aRaw === '-'
  const bIsDash = bRaw === '-'

  if (aIsDash && bIsDash) return 0
  if (aIsDash) return 1
  if (bIsDash) return -1

  const aStr = aRaw == null ? '' : String(aRaw)
  const bStr = bRaw == null ? '' : String(bRaw)

  return aStr.localeCompare(bStr, undefined, { numeric: true, sensitivity: 'base' })
}

// Helpers for ProductReturns sorting and display
export const stripLeadingLetters = (val) => {
  if (val == null) return ''
  const str = String(val)
  // remove a single leading letter and optional punctuation like ")", ".", ":", "-" and spaces
  return str.replace(/^\s*[a-zA-Z][)\.:\-]*\s*/u, '').trim()
}

const normalizeProductReturnsLabel = (val) => {
  if (val == null) return ''
  // base lowercase without leading letters like "a)", "b.", etc.
  const base = stripLeadingLetters(val).toLowerCase().trim()
  // normalize unicode greater-or-equal to ASCII and remove spaces and percent signs
  // examples:
  //  "5 - 10%" => "5-10"
  //  ">= 20%" => ">=20"
  //  "< 2 %" => "<2"
  return base.replace(/≥/g, '>=').replace(/\s+/g, '').replace(/%/g, '')
}

// Map ProductReturns buckets to ranks for ascending order
// Asc: <2%, 2-5%, 5-10%, 10-20%, >=20%, not enough data
const getProductReturnsRank = (val) => {
  // compact form without spaces/% and with ">=" normalized
  const v = normalizeProductReturnsLabel(val)
  // readable form (keeps spaces) for phrase detection
  const readable = stripLeadingLetters(val).toLowerCase().trim()

  if (v.startsWith('<2')) return 0
  if (v.startsWith('2-5')) return 1
  if (v.startsWith('5-10')) return 2
  if (v.startsWith('10-20')) return 3
  if (v.startsWith('>=20')) return 4
  if (readable.includes('not enough data')) return 5
  // Unknown labels get a large rank to appear at the end in asc (start) and at top in desc (end)
  return 999
}

export const productReturnsSort = (rowA, rowB, columnId) => {
  if (rowA.depth) return

  const aRaw = rowA.getValue(columnId)
  const bRaw = rowB.getValue(columnId)
  const rankA = getProductReturnsRank(aRaw)
  const rankB = getProductReturnsRank(bRaw)
  if (rankA !== rankB) return rankA - rankB
  // fallback to natural compare of cleaned labels
  const aStr = normalizeProductReturnsLabel(aRaw)
  const bStr = normalizeProductReturnsLabel(bRaw)
  return aStr.localeCompare(bStr, undefined, { numeric: true, sensitivity: 'base' })
}
